import { useState, useEffect, useReducer, useRef } from "react";
import axios from "axios";

import { getReducer } from "../../../utils";

import Banner from "./compoments/Banner";
import Brochure from "./compoments/Brochure";
import Statistics from "./compoments/Statistics";
import OurServices from "./compoments/OurServices";
import OurPartners from "./compoments/OurPartners";
import NewsEvents from "./compoments/NewsEvents";
import Feedback from "./compoments/Feedback";
import LoadingBox from "../../compoment/LoadingBox";
import MessageBox from "../../compoment/MessageBox";
import EnrollmentForm from "../enrollment/EnrollmentForm";
import ModalEnrollment from "../enrollment/ModalEnrollment";
import useIsDevice from "../../../format/useIsDevice";
import NewsProducts from "./compoments/NewsProducts";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS_BANNER":
      return { ...state, banners: action.payload, loading: false };
    case "FETCH_SUCCESS_OUR_PRODUCTS":
      return { ...state, ourProducts: action.payload, loading: false };
    case "FETCH_SUCCESS_VIDEO":
      return { ...state, video: action.payload, loading: false };
    case "FETCH_SUCCESS_INTRO_IMAGE":
      return { ...state, introImage: action.payload, loading: false };
    case "FETCH_SUCCESS_FEEDBACK":
      return { ...state, feedback: action.payload, loading: false };
    case "FETCH_SUCCESS_PARTNER":
      return { ...state, partner: action.payload, loading: false };
    case "FETCH_SUCCESS_POST":
      return { ...state, news: action.payload, loading: false };
    case "FETCH_SUCCESS_PRODUCTS":
      return { ...state, products: action.payload, loading: false };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const Main = () => {
  const [modalShow, setModalShow] = useState(false);
  const hasFetchedRef = useRef(false);
  const isTablet = useIsDevice(576, 991);
  const limitPost = isTablet ? 2 : 3;

  const [
    {
      loading,
      error,
      banners,
      video,
      introImage,
      news,
      feedback,
      partner,
      ourProducts,
      products,
    },
    dispatch,
  ] = useReducer(getReducer(reducer), {
    news: [],
    banners: [],
    video: null,
    introImage: null,
    feedback: null,
    partner: null,
    ourProducts: null,
    loading: true,
    error: "",
    products: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      if (hasFetchedRef.current) return;
      hasFetchedRef.current = true;

      dispatch({ type: "FETCH_REQUEST" });
      try {
        const {
          data: { data: sections },
        } = await axios.get("/page-section/public/shows?pageSlug=trang-chu");

        const getSectionContent = (type) =>
          sections
            .filter((item) => item.sectionType === type)
            .flatMap((item) => item.content);

        dispatch({
          type: "FETCH_SUCCESS_BANNER",
          payload: getSectionContent("banner"),
        });

        dispatch({
          type: "FETCH_SUCCESS_OUR_PRODUCTS",
          payload: getSectionContent("ourProducts"),
        });

        const videoContent = getSectionContent("video");

        dispatch({
          type: "FETCH_SUCCESS_VIDEO",
          payload: videoContent,
        });

        const introImage = getSectionContent("introImage");
        dispatch({
          type: "FETCH_SUCCESS_INTRO_IMAGE",
          payload: introImage[0] || null,
        });

        dispatch({
          type: "FETCH_SUCCESS_FEEDBACK",
          payload: getSectionContent("feedback"),
        });

        dispatch({
          type: "FETCH_SUCCESS_PARTNER",
          payload: getSectionContent("partner"),
        });

        const {
          data: {
            data: { posts },
          },
        } = await axios.get("/post/public/shows?page=1&limit=3");

        const extractPosts = (slug, title) => ({
          title,
          slug,
          data: posts,
        });

        const combinedData = [extractPosts("bai-viet", "Tin tức mới nhất")];

        dispatch({ type: "FETCH_SUCCESS_POST", payload: combinedData });

        const {
          data: {
            data: { products },
          },
        } = await axios.get("/product/public/shows?page=1&limit=3");

        dispatch({
          type: "FETCH_SUCCESS_PRODUCTS",
          payload: products,
        });
      } catch (err) {
        dispatch({ type: "FETCH_FAIL", payload: err.message });
      }
    };

    fetchData();

    const timer = setTimeout(() => setModalShow(true), 10000);
    return () => clearTimeout(timer);
  }, [limitPost]);

  return loading ? (
    <LoadingBox />
  ) : error ? (
    <MessageBox variant="danger">{error}</MessageBox>
  ) : (
    <div>
      <Banner data={banners} />
      <Brochure data={introImage} />
      <Statistics />
      <OurServices data={ourProducts} />
      <NewsEvents
        data={news?.map((item) => ({
          ...item,
          data: item.data.slice(0, limitPost),
        }))}
      />
      <NewsProducts data={products} />
      <Feedback data={feedback} />
      <OurPartners data={partner} />
      <EnrollmentForm />
      <ModalEnrollment show={modalShow} onHide={() => setModalShow(false)} />
    </div>
  );
};

export default Main;
